import { gql } from '@apollo/client/core';

export const audioEmbedBlockFragment = gql`
  fragment AudioEmbedBlockFields on AudioEmbedBlock {
    audioSrc
    audioTitle
    audioDescription
    audioFileCollection(limit: 5) {
      items {
        url
        title
      }
    }
  }
`;
